<template>
  <table class="table mt-5">
    <thead>
      <tr>
        <th>Typ</th>

        <th>Początek obowiązywania</th>

        <th>Koniec obowiązywania</th>

        <th>
          <span class="sr-only">Akcje</span>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(item, rowIndex) of model.$items" :key="'row_' + rowIndex">
        <td>
          <w-select :title="''" :tooltip-content="''" :model="item.$item.type" :values="types" />
        </td>

        <td>
          <w-datepicker title :model="item.$item.startDate" />
        </td>

        <td>
          <w-datepicker title :model="item.$item.endDate" />
        </td>

        <w-row-buttons
          class="middle"
          :model="item.$item"
          :move-up="rowIndex != 0"
          :move-down="item.$item.$parent.$value.length - 1 !== rowIndex"
        />
      </tr>
    </tbody>

    <tfoot>
      <tr>
        <td colspan="100%">
          <w-add-row class="btn-primary float-right" :model="model">Dodaj zakres dat</w-add-row>
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';
import moment from 'moment';

// @vuese
// Komponent wyświetlający zakresy dat decyzji
// @group Decision
export default {
  components,
  props: {
    // Model listy zakresów
    model: { type: Object, fieldRequired: true },
    // Typy dat
    types: { type: Array, fieldRequired: true }
  },

  mounted() {
    this.model.$items.forEach(item => {
      item.$item.startDate.$setData(moment(item.$item.startDate).format('DD-MM-YYYY'));
      item.$item.endDate.$setData(moment(item.$item.endDate).format('DD-MM-YYYY'));
    });
  }
};
</script>
